
import JessieOLP from './olp-jessie-min'

let OLP = JessieOLP.OLP;

(function () {

    if (!OLP.getDescendantsByClassName || !OLP.changeElementPresence || !OLP.addClass) {
        return;
    }
    var mobilizeHeader = function () {
        var mainMenu = OLP.getElement("main-menu");
        var mainMenuItems = OLP.getDescendantsByClassName(mainMenu, "main-menu-item");


        var accountMenu = OLP.getElement("account-menu");
        var accountMenuItems = [];
        if (accountMenu) {
            accountMenuItems = OLP.getDescendantsByClassName(accountMenu, "main-menu-item");
        }

        if (accountMenuItems.length + mainMenuItems.length == 0) return;

        OLP.changeElementPresence(mainMenu, false);
        if (accountMenu) {
            OLP.changeElementPresence(accountMenu, false);
        }

        OLP.getElement("body-header").style.textAlign = "left";

        var mobileMenu = OLP.getElement("mobile-menu");
        mobileMenu.style.display = "block";

        var mobileMenuList = OLP.getElement("mobile-menu-list");

        var mobileMenuHtml = "<ul class='mobile-menu-list'>";
        for (var i in mainMenuItems) {
            mobileMenuHtml += "<li class='main-menu-item'>" + mainMenuItems[i].innerHTML + "</li>";
        }
        for (var i in accountMenuItems) {
            mobileMenuHtml += "<li class='account-menu-item'>" + accountMenuItems[i].innerHTML + "</li>";
        }
        mobileMenuHtml += "</ul>";

        mobileMenuList.innerHTML = mobileMenuHtml;

        OLP.getDescendantsByTagName(mobileMenu, "img")[0].onclick = function (e) {
            if (OLP.hasClass(mobileMenu, "mobile-menu-active")) {
                OLP.removeClass(mobileMenu, "mobile-menu-active");
            } else {
                OLP.addClass(mobileMenu, "mobile-menu-active");
            }
        };
    };

    OLP.mobilize = function () {
        mobilizeHeader();
    }

})();
